import Drawer from 'components/Drawer'
import NotificationDetails from 'modules/Page/Components/Partials/NotificationDrawer/AllNotificationDetails/index'
import {
  CandidatesSpan,
  StyledTab,
} from 'modules/Page/Components/Partials/NotificationDrawer/style'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'

const CustomDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    transform: translateX(0);
    z-index: 1001;
  }
`

const Notification = ({
  notification,
  setNotification,
  userData,
  getNotificationsList,
  notificationData,
  markNotificationReadApi,
  driveData,

  getSingleCandidateInterviewDetails,
  getCandidateList,
  updateInterviewStatus,
  candidateInterviewDetails,
  rolesMetrics,
  getRoleMetrics,
  getRescheduleList,
  notifyReschedule,
  candidateDetails,
  getCandidateDetails,
  getRoleRounds,
  roundItemList,
  setLoading,
  notificationCount,
  setNotificationCount,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  interViewerList,
  createInterview,
  driveId,
  addCorporateBranch,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  getInterViewLocation,
  interViewData,
  corporateLocationsList,
  getCorporateLocationsList,
  getGroupDiscussionList,
  groupList,
  UpdateScheudle,
  getDriveRoleCandidatesList,
}) => {
  const [selectedTab, setSelectedTab] = useState('notification')
  const [allNotificationLoading, setAllNotificationLoading] = useState(true)
  const [allNotificationHasMoreData, setAllNotificationHasMoreData] =
    useState(true)
  const [allNotificationListData, setAllNotificationListData] = useState([])
  const [allNotificationPageNo, setAllNotificationPageNo] = useState(1)
  const [allNotificationCount, setAllNotificationCount] = useState(0)

  const [actionLoading, setActionLoading] = useState(true)
  const [actionHasMoreData, setActionHasMoreData] = useState(true)
  const [actionListData, setActionListData] = useState([])
  const [actionPageNo, setActionPageNo] = useState(1)
  const [actionCount, setActionCount] = useState(0)
  const notificationAsRead = payload => {
    markNotificationReadApi({ userId: userData?._id, payload: payload })
  }

  useEffect(() => {
    if (userData?._id)
      loadMoreData({
        pageNo: allNotificationPageNo,
        setLoading: setAllNotificationLoading,
        listData: allNotificationListData,
        setListData: setAllNotificationListData,
        setHasMoreData: setAllNotificationHasMoreData,
        setTotalCount: setAllNotificationCount,
        isAction: false,
      })
  }, [notification, allNotificationPageNo, userData])

  useEffect(() => {
    if (notification) {
      loadMoreData({
        pageNo: actionPageNo,
        setLoading: setActionLoading,
        listData: actionListData,
        setListData: setActionListData,
        setHasMoreData: setActionHasMoreData,
        setTotalCount: setActionCount,
        isAction: true,
      })
    }
  }, [notification, actionPageNo])

  const loadMoreData = async ({
    pageNo,
    setLoading,
    listData,
    setListData,
    setHasMoreData,
    setTotalCount,
    isAction,
  }) => {
    const { data } = await getNotificationsList({
      userId: userData?._id,
      currentPage: pageNo,
      isAction: isAction,
      setLoading: setLoading,
    })

    if (data?.data?.list?.length) {
      setTotalCount(data?.data?.count)
      setNotificationCount(data?.data?.notReadCount)
      const pendingList = [...listData, ...(data?.data?.list || [])]
      const arrFiltered = removeDuplicatesFromArray(pendingList, '_id')
      setListData(arrFiltered)
    } else {
      setTotalCount(0)
      setListData([])
      setHasMoreData(false)
    }
    if (data?.data?.totalPages == 1) {
      setHasMoreData(false)
    }
  }

  const onClose = () => {
    setNotification(false)
    setAllNotificationHasMoreData(true)
    setAllNotificationListData([])
    setAllNotificationPageNo(1)
    setActionHasMoreData(true)
    setActionListData([])
    setActionPageNo(1)
  }

  const content = () => {
    return (
      <StyledTab
        activeKey={selectedTab}
        onChange={key => setSelectedTab(key)}
        items={[
          {
            key: 'notification',
            label: (
              <>
                All Notifications{' '}
                <CandidatesSpan>{allNotificationCount}</CandidatesSpan>
              </>
            ),
            children: (
              <NotificationDetails
                notificationData={notificationData}
                notification={notification}
                setNotification={setNotification}
                notificationAsRead={notificationAsRead}
                loading={allNotificationLoading}
                hasMoreData={allNotificationHasMoreData}
                setHasMoreData={setAllNotificationHasMoreData}
                listData={allNotificationListData}
                pageNo={allNotificationPageNo}
                setPageNo={setAllNotificationPageNo}
                driveData={driveData}
                getSingleCandidateInterviewDetails={
                  getSingleCandidateInterviewDetails
                }
                candidateInterviewDetails={candidateInterviewDetails}
                getRoleMetrics={getRoleMetrics}
                rolesMetrics={rolesMetrics}
                getCandidateList={getCandidateList}
                updateInterviewStatus={updateInterviewStatus}
                getRescheduleList={getRescheduleList}
                notifyReschedule={notifyReschedule}
                getCandidateDetails={getCandidateDetails}
                candidateDetails={candidateDetails}
                getRoleRounds={getRoleRounds}
                roundItemList={roundItemList}
                onCloseParentDrawer={onClose} // Pass the onClose function
                setLoading={setLoading}
                interViewerList={interViewerList}
                createInterview={createInterview}
                driveInterViewerList={driveInterViewerList}
                getDriveInterviewerList={getDriveInterviewerList}
                getInterViewLocation={getInterViewLocation}
                interViewData={interViewData}
                addCorporateBranch={addCorporateBranch}
                getListOfCountries={getListOfCountries}
                getListOfStates={getListOfStates}
                getListOfCities={getListOfCities}
                listOfCountries={listOfCountries}
                listOfStates={listOfStates}
                listOfCities={listOfCities}
                corporateLocationsList={corporateLocationsList}
                getCorporateLocationsList={getCorporateLocationsList}
                getGroupDiscussionList={getGroupDiscussionList}
                groupList={groupList}
                UpdateScheudle={UpdateScheudle}
                getDriveRoleCandidatesList={getDriveRoleCandidatesList}
              />
            ),
          },
          {
            key: 'required',
            label: (
              <>
                Action Required <CandidatesSpan>{actionCount}</CandidatesSpan>
              </>
            ),
            children: (
              <NotificationDetails
                notificationData={notificationData}
                notification={notification}
                setNotification={setNotification}
                notificationAsRead={notificationAsRead}
                loading={actionLoading}
                hasMoreData={actionHasMoreData}
                setHasMoreData={setActionHasMoreData}
                listData={actionListData}
                pageNo={actionPageNo}
                setPageNo={setActionPageNo}
                driveData={driveData}
                getSingleCandidateInterviewDetails={
                  getSingleCandidateInterviewDetails
                }
                candidateInterviewDetails={candidateInterviewDetails}
                getRoleMetrics={getRoleMetrics}
                rolesMetrics={rolesMetrics}
                getCandidateList={getCandidateList}
                updateInterviewStatus={updateInterviewStatus}
                getRescheduleList={getRescheduleList}
                notifyReschedule={notifyReschedule}
                getCandidateDetails={getCandidateDetails}
                candidateDetails={candidateDetails}
                getRoleRounds={getRoleRounds}
                roundItemList={roundItemList}
                onCloseParentDrawer={onClose} // Pass the onClose function
                setLoading={setLoading}
                interViewerList={interViewerList}
                createInterview={createInterview}
                driveInterViewerList={driveInterViewerList}
                getDriveInterviewerList={getDriveInterviewerList}
                getInterViewLocation={getInterViewLocation}
                interViewData={interViewData}
                addCorporateBranch={addCorporateBranch}
                getListOfCountries={getListOfCountries}
                getListOfStates={getListOfStates}
                getListOfCities={getListOfCities}
                listOfCountries={listOfCountries}
                listOfStates={listOfStates}
                listOfCities={listOfCities}
                corporateLocationsList={corporateLocationsList}
                getCorporateLocationsList={getCorporateLocationsList}
                getGroupDiscussionList={getGroupDiscussionList}
                groupList={groupList}
                UpdateScheudle={UpdateScheudle}
                getDriveRoleCandidatesList={getDriveRoleCandidatesList}
              />
            ),
          },
        ]}
      />
    )
  }
  return (
    <div>
      <CustomDrawer
        width="40%"
        height="100%"
        title="Notification"
        placement="right"
        visible={notification}
        content={content()}
        onClose={onClose}
        closable
      />
    </div>
  )
}

export default Notification
